export default __webpack_public_path__ + "static/media/st-kitts-and-nevis.9f9be1f6.webp";